var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-box"},[_c('div',{staticClass:"card-box-header"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-box-body"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }